/* ============================================================
   dr.GUT — Player dos vídeos em bolinhas (stories)

   As bolinhas ficam na página; o player é criado uma vez, no fim do
   <body>, e reaproveitado. Um só <video> troca de fonte a cada vídeo:
   assim o navegador não mantém seis players vivos em memória, que é o
   que derruba o Safari do iPhone.

   A barra de progresso segue o TEMPO REAL do vídeo, não um cronômetro
   fixo. Em stories de vídeo é o que a pessoa espera: o traço acaba
   quando a fala acaba, e a passagem para o próximo é automática.
   ============================================================ */
(function () {
  'use strict';

  if (window.drgutStories) return;
  window.drgutStories = true;

  var ZONA = 0.3; /* terço lateral que navega; o meio pausa */
  var ARRASTO_FECHA = 110;

  var player = null;
  var el = {};
  var lista = [];
  var pos = 0;
  var focoAnterior = null;
  var pausadoPelaPessoa = false;

  /* Estado próprio, marcado no primeiro instante da abertura e do fecho.
     `player.hidden` não serve: ele só muda 220ms depois, quando o fade
     termina, e nesse intervalo a caixa ainda recebe toque. */
  var aberto = false;
  var relogioFade = null;

  /* Cada troca de vídeo ganha um número. Uma promessa de play que chega
     atrasada, de um vídeo que já saiu de cena, é descartada por ele. */
  var geracao = 0;

  /* Lido pelas filas de bolinhas para saberem que estão cobertas. */
  var playerAberto = false;

  /* ---------- Qual versão do vídeo pedir ----------

     O Shopify guarda cada vídeo em 480p, 720p e 1080p. O tema pedia
     sempre a primeira da lista, que é a maior: 1080p a 7,2 Mbps. Num 4G
     lento de ~1,6 Mbps esse arquivo não toca — cada segundo de imagem
     precisa de quatro segundos e meio de rede, e o player fica parado
     esperando o buffer que nunca enche.

     Quando a conexão não dá conta, o player usa a de 480p. Ela cabe na
     banda e começa quase na hora; a diferença de nitidez num celular é
     pequena perto de ficar meio minuto olhando para uma tela preta. */
  function redeLenta() {
    try {
      /* No celular a leve vale sempre, e não só por banda: a BOLINHA já
         baixou essa mesma versão de 480p. Pedir 720p no player seria outra
         URL e um download começando do zero, jogando fora o que a fila
         acabou de trazer. Com a mesma fonte, o player abre com o arquivo
         já em cache — e numa tela pequena a diferença de nitidez é pouca
         perto da diferença entre abrir na hora e esperar. */
      if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return true;

      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!c) return false;
      if (c.saveData) return true;
      if (/(^|-)2g$|^3g$/.test(c.effectiveType || '')) return true;
      /* downlink vem em Mbps e é uma média recente, não o pico. */
      if (typeof c.downlink === 'number' && c.downlink > 0 && c.downlink < 3) return true;
    } catch (e) {}
    return false;
  }

  /* Os dois elementos de vídeo do player e qual deles está no ar. */
  var videos = [];
  var slot = 0;

  /* A escolha de som é da pessoa e vale para a sessão inteira; cada vídeo
     novo nasce com ela. Antes o som era ligado só uma vez, na abertura, e
     o revezamento de elementos perdia esse estado. */
  var comSom = true;

  function reserva() {
    return videos[1 - slot];
  }

  /* O produto do card é o mesmo desta página? Comparação por caminho, sem
     o domínio nem parâmetros: o link vem do Liquid com ?variant=… às
     vezes, e o endereço da barra pode ter utm. */
  function mesmaPagina(url) {
    if (!url) return false;
    try {
      var a = new URL(url, window.location.origin);
      return a.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
    } catch (e) {
      return false;
    }
  }

  /* Rola até a escolha do kit, que é onde a oferta de verdade está. A
     âncora "comprar" é a mesma que o resto do tema usa; o recuo do
     cabeçalho fixo vem do scroll-margin declarado no CSS da seção. */
  function irParaOferta() {
    var alvo =
      document.getElementById('comprar') ||
      document.querySelector('[data-drgut-picker]') ||
      document.querySelector('[data-drgut-atc-anchor]');
    if (!alvo) return false;
    alvo.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  /* ---------- montagem, uma vez só ---------- */
  function montar() {
    if (player) return player;

    player = document.createElement('div');
    player.className = 'dgstp';
    player.setAttribute('role', 'dialog');
    player.setAttribute('aria-modal', 'true');
    player.setAttribute('aria-label', 'Vídeo');
    player.hidden = true;

    player.innerHTML =
      '<div class="dgstp__fundo" data-fechar></div>' +
      '<div class="dgstp__caixa">' +
      '<video class="dgstp__video is-ativo" playsinline preload="auto"></video>' +
      '<video class="dgstp__video" playsinline preload="metadata"></video>' +
      '<div class="dgstp__barra"></div>' +
      '<div class="dgstp__topo">' +
      '<span class="dgstp__quem"></span>' +
      '<button type="button" class="dgstp__btn" data-play aria-label="Pausar vídeo">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 5v14M15 5v14"/></svg>' +
      '</button>' +
      '<button type="button" class="dgstp__btn" data-som aria-label="Desativar som">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/></svg>' +
      '</button>' +
      '<button type="button" class="dgstp__btn" data-fechar aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
      '</button>' +
      '</div>' +
      /* Encaixe vazio: o card real vem do <template> da bolinha, montado
         em Liquid pelo mesmo snippet que o popup do Shopable Video usa.
         Antes este player desenhava um card próprio, com preço riscado —
         parecido com o do shoppable, nunca igual. Agora é o mesmo. */
      '<div class="dgstp__card-slot" hidden></div>' +
      '</div>';

    document.body.appendChild(player);

    el.caixa = player.querySelector('.dgstp__caixa');
    /* Dois elementos que se revezam: enquanto um toca, o outro já baixa o
       próximo. Trocar a fonte de um único elemento descartava o buffer e
       recomeçava o download do zero a cada passagem — era daí que vinha a
       espera no celular. */
    videos = [].slice.call(player.querySelectorAll('.dgstp__video'));
    el.video = videos[0];
    el.barra = player.querySelector('.dgstp__barra');
    el.quem = player.querySelector('.dgstp__quem');
    el.som = player.querySelector('[data-som]');
    el.play = player.querySelector('[data-play]');
    el.cardSlot = player.querySelector('.dgstp__card-slot');
    /* Preenchido a cada troca de vídeo, em pintarCard. */
    el.card = null;

    ligarEventos();
    return player;
  }

  /* ---------- barra ---------- */
  function montarBarra(total) {
    el.barra.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var seg = document.createElement('span');
      seg.className = 'dgstp__seg';
      var fill = document.createElement('i');
      fill.className = 'dgstp__fill';
      seg.appendChild(fill);
      el.barra.appendChild(seg);
    }
  }

  function pintarBarra() {
    var segs = el.barra.children;
    for (var i = 0; i < segs.length; i++) {
      segs[i].classList.toggle('is-done', i < pos);
      if (i === pos) continue;

      var f = segs[i].querySelector('.dgstp__fill');
      if (!f) continue;
      /* Para frente, zera. Para trás, apaga o estilo direto — senão ele
         vence a regra de "já visto" e o traço trava no meio. */
      f.style.transform = i > pos ? 'scaleX(0)' : '';
    }
  }

  function seguirVideo() {
    var seg = el.barra.children[pos];
    if (!seg) return;
    var v = el.video;
    if (!v.duration || !isFinite(v.duration)) return;
    var f = seg.querySelector('.dgstp__fill');
    if (f) f.style.transform = 'scaleX(' + Math.min(1, v.currentTime / v.duration) + ')';
  }

  /* ---------- troca de vídeo ---------- */
  function mostrar(i) {
    if (!lista.length) return;

    /* Dá a volta nas pontas, como num carrossel de stories. */
    pos = (i + lista.length) % lista.length;
    var d = lista[pos];

    pausadoPelaPessoa = false;

    var minhaVez = ++geracao;
    var alvo = reserva();

    /* Se a reserva já estava baixando este vídeo, ele começa quase na
       hora — é o ganho de ter dois elementos. */
    /* Quem entra no ar tem prioridade total de rede. */
    alvo.preload = 'auto';
    if (alvo.dataset.fonte !== d.video) {
      alvo.src = d.video;
      alvo.dataset.fonte = d.video;
      alvo.load();
    }

    /* A capa vira o fundo da caixa, em CSS. O atributo poster não serve
       aqui: pela especificação ele só é pintado enquanto o elemento nunca
       teve um quadro, e depois do primeiro vídeo essa condição é falsa
       para sempre. Era por isso que a tela ficava PRETA enquanto o
       próximo carregava, em vez de mostrar a foto. */
    el.caixa.style.backgroundImage = d.capa ? 'url("' + d.capa + '")' : '';
    el.caixa.classList.remove('tem-quadro');

    videos.forEach(function (v) {
      if (v === alvo) return;
      v.pause();
      v.classList.remove('is-ativo');
    });
    alvo.classList.add('is-ativo');
    slot = 1 - slot;
    el.video = alvo;

    alvo.muted = !comSom;
    /* currentTime antes de o vídeo ter metadados força uma busca no
       arquivo e adia o início. Só rebobina o que já tem o que rebobinar. */
    if (alvo.readyState >= 1 && alvo.currentTime > 0.05) {
      try { alvo.currentTime = 0; } catch (e) {}
    }
    alvo.play().catch(function (err) {
      /* Trocar a fonte cancela o play anterior, e o navegador avisa com
         erro. Tratar todo erro como "som recusado" mutava o player para o
         resto da sessão quando alguém pulava rápido de um vídeo a outro —
         que é o gesto mais comum aqui. */
      if (minhaVez !== geracao) return;
      if (!err || err.name !== 'NotAllowedError') return;

      if (!alvo.muted) {
        comSom = false;
        alvo.muted = true;
        sincronizarSom();
        alvo.play().catch(function () {});
      }
    });

    el.quem.textContent = d.nome || '';
    pintarBarra();
    pintarCard(d);
    sincronizarPlay();
  }

  /* Deixa o próximo vídeo baixando no elemento que ficou livre. */
  function precarregar(i) {
    if (lista.length < 2) return;
    var d = lista[(i + lista.length) % lista.length];
    var r = reserva();
    if (!d || !d.video || r.dataset.fonte === d.video) return;
    r.pause();
    /* A reserva baixa em segundo plano, sem disputar com quem está no ar. */
    r.preload = 'metadata';
    r.src = d.video;
    r.dataset.fonte = d.video;
    r.load();
  }

  function pintarCard(d) {
    el.cardSlot.innerHTML = '';
    el.card = null;

    if (!d.tplCard) {
      el.cardSlot.hidden = true;
      return;
    }

    el.cardSlot.hidden = false;
    el.cardSlot.appendChild(d.tplCard.content.cloneNode(true));
    el.card = el.cardSlot.querySelector('.dgvbar-card');
  }

  /* O ícone mostra o que o botão FAZ agora: tocando, ele oferece pausar.
     Quem manda é o estado do vídeo, não o último clique — assim ele
     continua certo quando o vídeo pausa sozinho (fim, aba escondida). */
  function sincronizarPlay() {
    if (!el.play || !el.video) return;
    var parado = el.video.paused;
    el.play.setAttribute('aria-label', parado ? 'Tocar vídeo' : 'Pausar vídeo');
    el.play.innerHTML = parado
      ? '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>';
  }

  function sincronizarSom() {
    var mudo = !comSom;
    el.som.setAttribute('aria-label', mudo ? 'Ativar som' : 'Desativar som');
    el.som.innerHTML = mudo
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="m16 9.5 5 5M21 9.5l-5 5"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H3v6h3l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/></svg>';
  }

  /* ---------- abrir e fechar ---------- */
  function abrir(itens, indice) {
    clearTimeout(relogioFade);
    aberto = true;
    playerAberto = true;
    montar();
    lista = itens;
    focoAnterior = document.activeElement;

    /* As bolinhas atrás da cortina param: elas não sabem que foram
       cobertas — o detector de visibilidade mede geometria, e a fila
       continua "à vista" debaixo do player. */
    document.dispatchEvent(new CustomEvent('dgst:abriu'));

    montarBarra(lista.length);
    player.hidden = false;
    player.classList.add('is-montado');
    requestAnimationFrame(function () { player.classList.add('is-aberto'); });
    document.documentElement.classList.add('dgstp-aberto');

    /* Abrir é um clique, e clique libera áudio nos navegadores. */
    comSom = true;
    mostrar(indice);
    sincronizarSom();
    sincronizarPlay();

    var x = player.querySelector('[data-fechar].dgstp__btn');
    if (x) x.focus({ preventScroll: true });
  }

  function fechar() {
    if (!player || !aberto) return;
    aberto = false;
    playerAberto = false;
    geracao++;
    document.dispatchEvent(new CustomEvent('dgst:fechou'));

    /* Solta os dois arquivos: sem isso o áudio pode seguir tocando em
       alguns navegadores depois que o elemento some da tela, e a reserva
       continuaria baixando um vídeo que ninguém vai ver. */
    videos.forEach(function (v) {
      v.pause();
      v.removeAttribute('src');
      delete v.dataset.fonte;
      v.load();
    });
    el.caixa.style.backgroundImage = '';

    player.classList.remove('is-aberto');
    document.documentElement.classList.remove('dgstp-aberto');
    relogioFade = setTimeout(function () {
      player.hidden = true;
      player.classList.remove('is-montado');
    }, 220);

    if (focoAnterior && focoAnterior.focus) focoAnterior.focus({ preventScroll: true });
  }

  /* ---------- eventos do player ---------- */
  function ligarEventos() {
    player.addEventListener('click', function (e) {
      /* Durante o fade de saída a caixa ainda existe e recebe toque. */
      if (!aberto) return;
      if (e.target.closest('[data-fechar]')) { fechar(); return; }

      if (e.target.closest('[data-play]')) {
        alternarPausa();
        return;
      }

      if (e.target.closest('[data-som]')) {
        comSom = !comSom;
        el.video.muted = !comSom;
        if (comSom) el.video.volume = 1;
        sincronizarSom();
        return;
      }

      /* O card leva ao produto; adicionar ao carrinho quando pedido. */
      var card = e.target.closest('.dgvbar-card');
      if (card) {
        var d = lista[pos];
        if (d && d.prodVariante) {
          e.preventDefault();
          adicionar(d.prodVariante);
          return;
        }

        /* Já estamos na página deste produto: fecha o vídeo e leva à
           escolha do kit, em vez de recarregar a mesma página. */
        if (d && mesmaPagina(d.prodUrl)) {
          e.preventDefault();
          fechar();
          setTimeout(irParaOferta, 240);
        }
        return;
      }

      var dentro = e.target.closest('.dgstp__caixa');
      if (!dentro) return;

      /* Terço esquerdo volta, direito avança, meio pausa — a divisão é
         calculada pela posição do dedo, e não por caixas invisíveis que
         teriam de ser encaixadas entre o card, os botões e a barra. */
      var r = el.caixa.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;

      if (x <= ZONA) mostrar(pos - 1);
      else if (x >= 1 - ZONA) mostrar(pos + 1);
      else alternarPausa();
    });

    function alternarPausa() {
      if (el.video.paused) {
        el.video.play().catch(function () {});
        pausadoPelaPessoa = false;
      } else {
        el.video.pause();
        pausadoPelaPessoa = true;
      }
      sincronizarPlay();
    }

    /* Os ouvintes vão nos DOIS elementos, e cada um só age quando é o que
       está no ar — o da reserva está baixando o próximo e não deve mexer
       na barra nem avançar nada. */
    videos.forEach(function (v) {
      v.addEventListener('timeupdate', function () {
        if (v === el.video) seguirVideo();
      });

      /* Acabou: passa para o próximo. No último, fecha — é o que os
         stories fazem, e evita um laço eterno com som. */
      v.addEventListener('ended', function () {
        if (v !== el.video || !aberto) return;
        if (pos >= lista.length - 1) fechar();
        else mostrar(pos + 1);
      });

      /* Fonte quebrada é tratada como fim de vídeo: sem isto a pessoa
         fica parada numa tela preta, sem nada acontecer. */
      v.addEventListener('error', function () {
        if (v !== el.video || !aberto) return;
        if (pos >= lista.length - 1) fechar();
        else mostrar(pos + 1);
      });

      v.addEventListener('play', function () {
        if (v === el.video) sincronizarPlay();
      });
      v.addEventListener('pause', function () {
        if (v === el.video) sincronizarPlay();
      });

      /* Chegou quadro: a capa de fundo sai de cena. */
      v.addEventListener('playing', function () {
        if (v !== el.video) return;
        el.caixa.classList.add('tem-quadro');

        /* SÓ AGORA o próximo começa a baixar. Disparar o pré-carregamento
           junto com a abertura fazia dois vídeos brigarem pela mesma
           banda, e o que a pessoa queria ver era o que esperava. */
        precarregar(pos + 1);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!player || !aberto) return;
      if (e.key === 'Escape') { e.preventDefault(); fechar(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); mostrar(pos + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); mostrar(pos - 1); }
      else if (e.key === ' ') { e.preventDefault(); alternarPausa(); }
    });

    /* Puxar para baixo fecha. Só assume o gesto quando ele é claramente
       vertical, para não brigar com a rolagem nem com o toque que navega. */
    var puxaY = null;
    var puxaX = null;
    var puxando = false;

    el.caixa.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      puxaY = e.touches[0].clientY;
      puxaX = e.touches[0].clientX;
      puxando = false;
    }, { passive: true });

    el.caixa.addEventListener('touchmove', function (e) {
      if (puxaY === null || e.touches.length !== 1) return;
      var dy = e.touches[0].clientY - puxaY;
      var dx = e.touches[0].clientX - puxaX;
      if (!puxando) {
        if (dy < 14 || Math.abs(dy) < Math.abs(dx) * 1.4) return;
        puxando = true;
      }
      if (dy <= 0) return;
      el.caixa.style.transition = 'none';
      el.caixa.style.transform = 'translateY(' + dy + 'px)';
      el.caixa.style.opacity = String(Math.max(0, 1 - dy / 420));
    }, { passive: true });

    el.caixa.addEventListener('touchend', function (e) {
      if (puxaY === null) return;
      var dy = e.changedTouches[0].clientY - puxaY;
      var fechou = puxando && dy > ARRASTO_FECHA;
      puxaY = null;
      puxaX = null;
      puxando = false;

      el.caixa.style.transition = 'transform .22s ease, opacity .22s ease';
      el.caixa.style.transform = '';
      el.caixa.style.opacity = '';
      if (fechou) fechar();
      else setTimeout(function () { el.caixa.style.transition = ''; }, 240);
    }, { passive: true });

    /* Aba escondida: pausa. Voltando, só retoma se não foi a pessoa que
       pausou de propósito. */
    document.addEventListener('visibilitychange', function () {
      if (!player || !aberto) return;
      if (document.hidden) el.video.pause();
      else if (!pausadoPelaPessoa) el.video.play().catch(function () {});
    });
  }

  function adicionar(id) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (res) {
        /* 422 é o "não foi possível adicionar" da Shopify — sem estoque,
           por exemplo. Ele chega como resposta normal, não como falha de
           rede, e era tratado como sucesso. */
        if (!res.ok) throw new Error('add falhou: ' + res.status);
        return res.json();
      })
      .then(function () {
        if (!aberto) return;
        fechar();
        /* Abre o carrinho do tema, se ele existir. */
        var gaveta = document.querySelector('.minicart__action, #cart-icon-bubble');
        if (gaveta) gaveta.click();
        else window.location.href = '/cart';
      })
      .catch(function () {
        /* Nada de mandar a pessoa para /cart: nada foi adicionado. */
        if (aberto && el.card) el.card.classList.add('is-erro');
      });
  }

  /* ---------- a fila de bolinhas ---------- */
  function dadosDaFila(fila) {
    return [].slice.call(fila.querySelectorAll('[data-dgst-abrir]')).map(function (b) {
      var leve = b.getAttribute('data-video-leve');
      /* O <template> com o card é o irmão imediato do botão da bolinha. */
      var prox = b.nextElementSibling;
      var tpl = prox && prox.tagName === 'TEMPLATE' && prox.hasAttribute('data-dgst-card') ? prox : null;
      return {
        tplCard: tpl,
        video: (leve && redeLenta()) ? leve : (b.getAttribute('data-video') || leve),
        capa: b.getAttribute('data-capa'),
        nome: b.getAttribute('data-nome'),
        prodNome: b.getAttribute('data-prod-nome'),
        prodUrl: b.getAttribute('data-prod-url'),
        prodPreco: b.getAttribute('data-prod-preco'),
        prodCheio: b.getAttribute('data-prod-cheio'),
        prodImg: b.getAttribute('data-prod-img'),
        prodVariante: b.getAttribute('data-prod-variante'),
      };
    });
  }

  /* ============================================================
     Autoplay das bolinhas
     ============================================================ */
  function ligarFila(fila) {
    if (fila.dataset.dgstLigada) return;
    fila.dataset.dgstLigada = '1';

    var videos = [].slice.call(fila.querySelectorAll('[data-dgst-video]'));
    if (!videos.length) return;

    var celular = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var modo = fila.getAttribute(celular ? 'data-modo-mobile' : 'data-modo') || 'todos';
    var segundos = parseFloat(fila.getAttribute('data-segundos')) || 4;
    var naTela = false;
    var vez = 0;
    var relogio = null;

    /* Conexão econômica, dados limitados ou preferência por menos
       movimento: fica só a capa. Vídeo em bolinha é enfeite — não vale
       gastar o pacote de dados de quem pediu para economizar. */
    var leve = false;
    try {
      var con = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (con && (con.saveData || /(^|-)2g$/.test(con.effectiveType || ''))) leve = true;
    } catch (e) {}
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) leve = true;
    if (leve || modo === 'nenhum') return;

    /* Quais bolinhas estão de fato à vista DENTRO da fila. Ela rola na
       horizontal: no celular cabem três, e as outras tocavam escondidas,
       decodificando vídeo que ninguém vê. */
    var visiveis = [];
    function estaVisivel(v) {
      return visiveis.indexOf(v) !== -1;
    }

    /* O arquivo só desce quando o vídeo vai tocar: seis fontes declaradas
       no HTML fariam o navegador baixar tudo junto no primeiro acesso. */
    function garantirFonte(v) {
      if (v.src || !v.dataset.src) return;
      v.src = v.dataset.src;
    }

    function tocar(v) {
      garantirFonte(v);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function pausarTodos() {
      videos.forEach(function (v) { v.pause(); });
    }

    function rodizio(i) {
      clearTimeout(relogio);
      if (!naTela || !videos.length) return;

      /* Pula quem está fora da parte visível da fila: senão a vez cai numa
         bolinha escondida e a pessoa vê tudo parado por vários segundos. */
      var tentativas = 0;
      vez = (i + videos.length) % videos.length;
      while (visiveis.length && !estaVisivel(videos[vez]) && tentativas < videos.length) {
        vez = (vez + 1) % videos.length;
        tentativas++;
      }
      videos.forEach(function (v, k) {
        if (k === vez) return;
        v.pause();
        v.currentTime = 0;
      });
      tocar(videos[vez]);
      relogio = setTimeout(function () { rodizio(vez + 1); }, segundos * 1000);
    }

    function comecar() {
      /* Player aberto por cima: a fila fica quieta. A guarda mora aqui, e
         não só no evento, para o retorno à aba não ressuscitar a fila com
         o player ainda aberto. */
      if (playerAberto) return;
      if (modo === 'todos') {
        videos.forEach(function (v) {
          if (estaVisivel(v)) tocar(v);
          else v.pause();
        });
      } else if (modo === 'sequencia') {
        rodizio(vez);
      }
    }

    function parar() {
      clearTimeout(relogio);
      pausarTodos();
    }

    /* Player aberto: as bolinhas soltam os arquivos.

       Pausar não basta — um vídeo pausado com src continua enchendo o
       buffer, e essas conexões concorriam com o vídeo em tela cheia
       justamente no instante em que ele precisa da banda inteira. Ao
       fechar, a fonte volta na primeira vez que a bolinha for tocar. */
    function soltarArquivos() {
      clearTimeout(relogio);
      videos.forEach(function (v) {
        v.pause();
        if (!v.src) return;
        v.removeAttribute('src');
        v.load();
      });
    }

    /* Sem mouse de verdade — celular e tablet — o hover é emulado pelo
       toque, e a fila ficaria sem nenhum modo de tocar. Cai no padrão. */
    if (modo === 'hover' && !(window.matchMedia && window.matchMedia('(pointer: fine)').matches)) {
      modo = 'todos';
    }

    if (modo === 'hover') {
      videos.forEach(function (v) {
        var alvo = v.closest('[data-dgst-abrir]') || v;
        alvo.addEventListener('mouseenter', function () {
          if (playerAberto || !naTela) return;
          tocar(v);
        });
        alvo.addEventListener('mouseleave', function () { v.pause(); v.currentTime = 0; });
      });
      /* Sem `return` aqui: o observador e o ouvinte de aba abaixo também
         precisam valer no hover, senão é o único modo que nunca pausa. */
    }

    /* Cada bolinha é observada dentro da própria fila, que rola de lado. */
    if ('IntersectionObserver' in window) {
      var obsItem = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var i = visiveis.indexOf(e.target);
          if (e.isIntersecting && i === -1) visiveis.push(e.target);
          else if (!e.isIntersecting && i !== -1) {
            visiveis.splice(i, 1);
            e.target.pause();
          }
        });
        if (naTela) comecar();
      }, { root: fila, threshold: 0.5 });
      videos.forEach(function (v) { obsItem.observe(v); });
    } else {
      visiveis = videos.slice();
    }

    /* Só toca com a fila à vista: vídeo rodando fora da tela é dado e
       bateria gastos à toa, e no celular ainda concorre com a rolagem. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          naTela = e.isIntersecting;
          if (naTela) comecar();
          else parar();
        });
      }, { threshold: 0.25 }).observe(fila);
    } else {
      naTela = true;
      comecar();
    }

    /* Aba escondida: nada tocando. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar();
      else if (naTela) comecar();
    });

    /* O player avisa quando entra e quando sai. */
    document.addEventListener('dgst:abriu', soltarArquivos);
    document.addEventListener('dgst:fechou', function () {
      if (naTela) comecar();
    });
  }

  function ligarTodasAsFilas() {
    document.querySelectorAll('[data-drgut-stories]').forEach(ligarFila);
  }

  /* Depois do load, não do DOMContentLoaded.

     No HAR de 08/09/2026 as bolinhas começavam a baixar aos 12,2s, com
     a página ainda montando: dois vídeos disputavam banda com o CSS, as
     fontes e as imagens do produto, e o load só fechava aos 22,8s. O
     enfeite atrasava o conteúdo.

     Agora a fila espera a página ficar pronta e ainda aguarda um respiro
     de ociosidade — quem chega para comprar vê o produto primeiro. */
  function ligarQuandoSobrar() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(ligarTodasAsFilas, { timeout: 2500 });
    } else {
      setTimeout(ligarTodasAsFilas, 600);
    }
  }

  if (document.readyState === 'complete') {
    ligarQuandoSobrar();
  } else {
    window.addEventListener('load', ligarQuandoSobrar);
  }

  /* No editor de temas o bloco é redesenhado a cada ajuste; a marca
     dgstLigada evita ligar duas vezes a mesma fila. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', ligarTodasAsFilas);
    document.addEventListener('shopify:block:select', ligarTodasAsFilas);
  }

  /* Delegado: o bloco é redesenhado no editor de temas, e ouvintes
     presos às bolinhas antigas morreriam junto com elas. */
  document.addEventListener('click', function (e) {
    var bolha = e.target.closest && e.target.closest('[data-dgst-abrir]');
    if (!bolha) return;

    var fila = bolha.closest('[data-drgut-stories]');
    if (!fila) return;

    e.preventDefault();
    var itens = dadosDaFila(fila);
    var indice = [].indexOf.call(fila.querySelectorAll('[data-dgst-abrir]'), bolha);
    if (itens.length) abrir(itens, Math.max(0, indice));
  });
})();
